'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require('react-intl');

var monthLabels = (0, _reactIntl.defineMessages)({
    1: {
        'id': 'formOptions.monthLabels.1',
        'defaultMessage': 'January'
    },
    2: {
        'id': 'formOptions.monthLabels.2',
        'defaultMessage': 'February'
    },
    3: {
        'id': 'formOptions.monthLabels.3',
        'defaultMessage': 'March'
    },
    4: {
        'id': 'formOptions.monthLabels.4',
        'defaultMessage': 'April'
    },
    5: {
        'id': 'formOptions.monthLabels.5',
        'defaultMessage': 'May'
    },
    6: {
        'id': 'formOptions.monthLabels.6',
        'defaultMessage': 'June'
    },
    7: {
        'id': 'formOptions.monthLabels.7',
        'defaultMessage': 'July'
    },
    8: {
        'id': 'formOptions.monthLabels.8',
        'defaultMessage': 'August'
    },
    9: {
        'id': 'formOptions.monthLabels.9',
        'defaultMessage': 'September'
    },
    10: {
        'id': 'formOptions.monthLabels.10',
        'defaultMessage': 'October'
    },
    11: {
        'id': 'formOptions.monthLabels.11',
        'defaultMessage': 'November'
    },
    12: {
        'id': 'formOptions.monthLabels.12',
        'defaultMessage': 'December'
    }
});

exports.default = monthLabels;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/month/monthLabels.js
// module id = 1375
// module chunks = 0